import { fmt, fmtDate } from '@dcc-erp/shared';
import type { PettyCashClose } from '@dcc-erp/shared';

import { CountCloseStatusBadge } from './pc-helpers';

// ─── Float-close section (PCX) — close-out requests list + approval trigger ──
export function PCClosesSection({
  closes,
  onOpenApproval,
}: {
  closes: readonly PettyCashClose[];
  onOpenApproval: (close: PettyCashClose) => void;
}) {
  return (
    <div className="tbl-shell" style={{ marginTop: 16 }}>
      <div className="filter-row">
        <span style={{ fontWeight: 600, fontSize: 14 }}>การปิด Float (Close-out)</span>
        <span className="muted" style={{ fontSize: 13 }}>
          คืนเงินสดคงเหลือเข้าบัญชีธนาคาร แล้วปิด float
        </span>
        <div style={{ marginLeft: 'auto' }}>
          <span className="meta">แสดง {closes.length} รายการ</span>
        </div>
      </div>
      <div className="tbl-wrap" style={{ maxHeight: 320 }}>
        <table className="tbl">
          <thead>
            <tr>
              <th>เลขที่</th>
              <th>วันที่ปิด</th>
              <th className="num">เงินคืน</th>
              <th>บัญชีปลายทาง</th>
              <th>สถานะ</th>
              <th style={{ width: 90 }} />
            </tr>
          </thead>
          <tbody>
            {closes.length === 0 ? (
              <tr>
                <td
                  colSpan={6}
                  style={{ textAlign: 'center', padding: 28, color: 'var(--text-muted)' }}
                >
                  ยังไม่มีคำขอปิด float นี้
                </td>
              </tr>
            ) : (
              closes.map((c) => (
                <tr key={c.id}>
                  <td className="code" style={{ color: 'var(--brand)', fontWeight: 500 }}>
                    {c.voucherNo}
                  </td>
                  <td>{fmtDate(c.closeDate)}</td>
                  <td className="num tnum">
                    <b>{fmt(Number(c.returnedAmount))}</b>
                  </td>
                  <td className="code">{c.toAccountCode}</td>
                  <td>
                    <CountCloseStatusBadge status={c.status} approvalStatus={c.approvalStatus} />
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn sm ghost"
                      data-testid={`pc-open-close-approval-${c.id}`}
                      style={{ fontSize: 12, height: 22, padding: '0 6px' }}
                      onClick={() => onOpenApproval(c)}
                      title="ดูสายอนุมัติ"
                    >
                      สายอนุมัติ
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
